import { Link } from "react-router-dom"
const Gallery = () => {
    return (
        <section className="my-5 mijsc-programs p-5 md:pt-14">
            <div className="my-5">
                <h2 className="text-4xl font-bold">Gallery</h2>
                <p className="pb-5 mb-5 mt-2">
                    Movements from Our Programs and Events
                </p>
            </div>

            <div className="px-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 place-content-center">

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/1.jpg)` }}
                    />
                </div>

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/2.jpg)` }}
                    />
                </div>

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/3.jpg)` }}
                    />
                </div>

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/4.jpg)` }}
                    />
                </div>

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/5.jpg)` }}
                    />
                </div>

                <div>
                    <div
                        className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/6.jpg)` }}
                    />
                </div>

            </div>
            <Link to="/gallery">
                <div className="mb-5 w-full pt-5 mt-5 place-content-center gap-10 place-items-center">
                    <div className="font-bold py-3 bg-green-600 text-white w-fit px-5 rounded-md text-sm">
                        View All
                    </div>
                </div>
            </Link>
        </section>

    )
}

export default Gallery
